import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";
const buttonVariants = cva("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-[14.5px] font-semibold transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:ring-ring focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-background aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", {
  variants: {
    variant: {
      // The filled button is ink on paper in light, brass on ebony in dark.
      // It brightens on hover rather than fading: an opacity step would turn
      // the brass grey against the dark background.
      default: "bg-primary text-primary-foreground hover:brightness-110",
      destructive: "bg-destructive text-destructive-foreground hover:brightness-110 focus-visible:ring-destructive",
      outline: "border border-border bg-transparent hover:bg-accent",
      /** The design's secondary button: a full-strength rule, no fill. */
      outlineStrong: "border border-ptl-rule-strong bg-transparent text-foreground hover:bg-accent",
      secondary: "bg-secondary text-secondary-foreground hover:bg-accent",
      ghost: "hover:bg-accent",
      link: "text-ptl-brass underline-offset-4 hover:underline"
    },
    size: {
      default: "h-11 px-[18px] has-[>svg]:px-4",
      sm: "h-10 px-4 has-[>svg]:px-3",
      lg: "h-[50px] px-[22px] text-[15px]",
      xs: "h-9 gap-1.5 px-3 text-[13px]",
      icon: "size-11",
      "icon-sm": "size-10"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
});
function Button(t0) {
  const $ = _c(14);
  let className;
  let props;
  let size;
  let t1;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      variant,
      size,
      asChild: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = size;
    $[4] = t1;
    $[5] = variant;
  } else {
    className = $[1];
    props = $[2];
    size = $[3];
    t1 = $[4];
    variant = $[5];
  }
  const asChild = t1 === undefined ? false : t1;
  const Comp = asChild ? Slot : "button";
  let t2;
  if ($[6] !== className || $[7] !== size || $[8] !== variant) {
    t2 = cn(buttonVariants({
      variant,
      size,
      className
    }));
    $[6] = className;
    $[7] = size;
    $[8] = variant;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== Comp || $[11] !== props || $[12] !== t2) {
    t3 = <Comp data-slot="button" className={t2} {...props} />;
    $[10] = Comp;
    $[11] = props;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}
export { Button, buttonVariants };